import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import images from '../constants/images'

export default function About() {

    const { t, i18n } = useTranslation()
    const [currentLang, setCurrentLang] = useState(i18n.language.split("-")[0])


    const formatTextWithNewLines = (text) => {
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    };

    return (
        <div className='h-full  w-full '>

            <div className='bg-beige h-fit items-center justify-center text-center mx-auto rounded-3xl shadow-lg lg:w-3/4  '>
                <h1 className='text-center text-2xl font-bold  mb-5'>{t('about.title')}</h1>
                <h1 className='font-bold'>{t('about.short_desc')}</h1>
                

                <div className='flex lg:flex-row items-center text-center justify-center'>
                    <img className=" lg:w-72 w-36 h-auto  rounded-xl"
                        src={images.preview_2} alt="" />

                    <div className='items-center lg:w-96  ml-10 '>
                    <h1 className='font-bold  text-2xl mb-3  bg-sunflower p-5 rounded-3xl'>{t("about.title_1")}</h1>
                        <p className='font-bold'>{formatTextWithNewLines(t('about.paragraph_1'))}</p>
                    </div>
                </div>

                <div className='flex lg:flex-row items-center text-center justify-center'>

                    <div className='items-center lg:w-96  justify-center'>
                        <h1 className='font-bold  text-2xl mb-3  bg-button_color p-5 rounded-3xl'>{t("about.title_2")}</h1>
                        <p className='font-bold'>{formatTextWithNewLines(t('about.paragraph_2'))}</p>
                    </div>

                    <img className=" lg:w-72 w-36 h-auto ml-10  rounded-xl"
                        src={images.preview_3} alt="" />
                </div>

                <div className='flex lg:flex-row  items-center text-center  justify-center'>
                    <img className="lg:w-72 w-36 h-auto rounded-xl"
                        src={images.preview_4} alt="" />

                    <div className='items-center lg:w-96   justify-center ml-10 '>
                        <h1 className='font-bold text-2xl mb-3  bg-sunflower p-5 rounded-3xl'>{t("about.title_3")}</h1>
                        <p className='font-bold'>{formatTextWithNewLines(t('about.paragraph_3'))}</p>
                    </div>
                </div>

                <p className='font-bold text-2xl mt-10'>{formatTextWithNewLines(t('about.paragraph_4'))}</p>
                <p className='font-bold  mb-20'>{t('about.coming_soon')}</p>


            </div>


        </div>
    )
}
